<template>
  <div :class="$style.overlay">
    <div :class="$style.inner">
      <img :src="logoSrc" alt="logo" :class="$style.logo" />
      <div :class="$style.statusWrap">
        <div :class="$style.statusBar">
          <div
            :class="$style.statusBarFill"
            :style="{ width: progressWidth }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppLoader",
  computed: {
    logoSrc() {
      return require("@/assets/img/logo.svg")
    },
    requestsCount() {
      return this.$store?.state?.requestsCount ?? 0
    },
    progressWidth() {
      // Чем меньше активных запросов, тем больше заполнение.
      const n = this.requestsCount
      if (n <= 0) return "100%"
      const maxVisual = 4 // после 4+ запросов прогресс просто выглядит «минимальным»
      const clamped = Math.min(n, maxVisual)
      const done = maxVisual - clamped
      const percent = (done / maxVisual) * 100
      return `${Math.max(10, percent)}%`
    },
  },
}
</script>

<style lang="scss" module>
.overlay {
  position: fixed;
  inset: 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.logo {
  width: 10rem;
  height: 10rem;
  animation: logoPulse 1.5s ease-in-out infinite;
  opacity: 0.4;
}

.statusWrap {
  width: 80%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.statusBar {
  width: 100%;
  height: 0.4rem;
  border-radius: 999px;
  background: #ffe4cc;
  overflow: hidden;
}

.statusBarFill {
  height: 100%;
  border-radius: inherit;
  background: #ff7a00;
  animation: barPulse 1.4s ease-in-out infinite;
  transition: width 0.2s ease-out;
}

@keyframes barPulse {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}

@keyframes logoPulse {
  0%,
  100% {
    opacity: 0.25;
  }
  50% {
    opacity: 1;
  }
}
</style>
